import type { SxProps, Theme } from '@mui/material/styles';

// CopilotDataTable (custom MUI Table)
export const copilotTableContainer: SxProps<Theme> = {
  bgcolor: '#fff',
  border: '1px solid #e8ebf2',
  borderRadius: '10px',
  overflowX: 'auto',
  p: '1px',
} as const;

export const copilotTableTitleRow: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  mt: '16px',
  mb: '12px',
} as const;

export const copilotTableTitle: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '16px',
  color: '#5f6978',
} as const;

export const copilotTableHeaderCell: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '16px',
  color: '#5f6978',
  py: '9px',
  px: '12px',
  borderBottom: '1px solid #e8ebf2',
  whiteSpace: 'nowrap',
} as const;

export const copilotTableBodyCell: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: 12,
  lineHeight: '16px',
  color: '#152232',
  py: '11.5px',
  px: '12px',
  borderBottom: '1px solid #e8ebf2',
  whiteSpace: 'nowrap',
} as const;

// CopilotKpiRow
export const copilotKpiGrid: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '8px',
  width: '100%',
} as const;

export const copilotKpiCard: SxProps<Theme> = {
  bgcolor: '#fff',
  border: '1px solid #e8ebf2',
  borderRadius: '10px',
  p: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minHeight: 90,
} as const;

export const copilotKpiCardLabel: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: 12,
  lineHeight: '16px',
  color: '#5f6978',
} as const;

export const copilotKpiCardValue: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: 20,
  lineHeight: '26px',
  color: '#01060d',
} as const;

// Compact KPI variant (used for dense outputs like waterfall)
export const copilotKpiGridCompact: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '6px',
  width: '100%',
} as const;

export const copilotKpiCardCompact: SxProps<Theme> = {
  bgcolor: '#fff',
  border: '1px solid #e8ebf2',
  borderRadius: '8px',
  p: '8px',
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
} as const;

export const copilotKpiCardLabelCompact: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: 11,
  lineHeight: '15px',
  color: '#5f6978',
} as const;

export const copilotKpiCardValueCompact: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '19px',
  color: '#01060d',
} as const;

export const copilotKpiTrendRow: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
} as const;

// Section title — shared by KPI, line chart, and business-signals renderers.
// 16px above / 12px below for consistent vertical rhythm across viz blocks.
export const copilotSectionTitle: SxProps<Theme> = {
  fontSize: 12,
  fontWeight: 600,
  color: '#5F6978',
  fontFamily: 'Inter, sans-serif',
  lineHeight: '16px',
  mt: '16px',
  mb: '12px',
} as const;

// CopilotLineChart
export const copilotChartContainer: SxProps<Theme> = {
  bgcolor: '#fff',
  border: '1px solid #e8ebf2',
  borderRadius: '10px',
  pt: '17px',
  px: '17px',
  pb: '1px',
} as const;

// CopilotBusinessSignals
export const copilotSignalCardNegative: SxProps<Theme> = {
  bgcolor: '#feebee',
  border: '1px solid rgba(238,32,73,0.2)',
  borderRadius: '10px',
  pt: '12px',
  pb: '16px',
  px: '12px',
} as const;

export const copilotSignalCardPositive: SxProps<Theme> = {
  bgcolor: '#dffae5',
  border: '1px solid rgba(66,174,92,0.2)',
  borderRadius: '10px',
  pt: '12px',
  pb: '16px',
  px: '12px',
} as const;

export const copilotSignalTitle: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: 14,
  lineHeight: '20px',
  color: '#01060d',
} as const;

export const copilotSignalDescription: SxProps<Theme> = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '20px',
  color: '#2d3949',
} as const;
